<template>

  <div tabindex="-1" role="menu"
       class="rm-pointers dropdown-menu-lg dropdown-menu dropdown-menu-right show cursor-auto">

    <t-dialog-support/>

    <t-dialog-download-app/>

    <div class="dropdown-menu-header">
      <div class="dropdown-menu-header-inner bg-gradient-light">
        <div class="menu-header-image opacity-2"></div>
        <div class="menu-header-content text-left">
          <div class="widget-content p-0">
            <div class="widget-content-wrapper">
              <div class="widget-content-left">
                <div class="widget-heading">{{ user.name }}</div>
                <div class="widget-subheading opacity-8">
                  {{ user.username }}<br/>
                  {{ user.profile }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <li class="nav-item-header nav-item">Configurações</li>


    <li class="nav-item">
      <b-link :to="{name:'my-report'}" @click="closeSubmenu" class="nav-link">
        <b-icon-file-earmark-richtext class="nav-link-icon"/>
        <span>Meus Relatórios</span></b-link>
    </li>

    <li class="nav-item">
      <b-link :to="{name:'my-user-history'}" @click="closeSubmenu" class="nav-link">
        <b-icon-person class="nav-link-icon"/>

        <span>Histórico de Acesso</span></b-link>
    </li>

    <li class="nav-item">
      <b-link :to="{name:'my-user-change-password'}" @click="closeSubmenu" class="nav-link">
        <b-icon-shield-lock class="nav-link-icon"/>
        <span>Alterar Senha</span>
      </b-link>
    </li>


    <ul class="nav flex-column">
      <li class="nav-item-divider mb-0 nav-item"></li>
    </ul>

    <li class="nav-item">
      <b-link @click="openSupport" class="nav-link">
        <b-icon-info-circle class="nav-link-icon"/>
        <span>Central do Cliente</span>
      </b-link>

    </li>

    <li class="nav-item">

      <b-link @click="openDownloadApp" class="nav-link">
        <b-icon-download class="nav-link-icon"/>
        <span>Download App</span>
      </b-link>

    </li>


    <ul class="nav flex-column">
      <li class="nav-item-divider mb-0 nav-item"></li>
    </ul>

    <li class="nav-item">
      <b-link @click="exit" class="nav-link">
        <b-icon-box-arrow-left class="nav-link-icon"/>
        Sair
      </b-link>
    </li>
    <div v-if="mobile">
      <li class="nav-item-divider nav-item"></li>
      <li class="nav-item-btn text-center nav-item">
        <button @click="closeSubmenu" class="btn-wide btn btn-primary">
          Fechar
        </button>
      </li>

    </div>


  </div>
</template>
<script>
import ui from "@/assets/scripts/ui"
import tDialogSupport from "@/components/template/dialog/t-dialog-support"
import tDialogDownloadApp from "@/components/template/dialog/t-dialog-download-app"
import myUserService from "@/services/modules/general/MyUser.service";

export default {
  name: 't-app-user-submenu',
  components: {tDialogSupport, tDialogDownloadApp},
  data() {
    return {}
  },
  props: {
    mobile: Boolean,
    user: {
      type: Object,
      required: true,
    },
  },
  methods: {
    async openSupport() {

      await myUserService.getCustomerServiceCenterToken().then((customerServiceCenterToken) => {

        if (customerServiceCenterToken !== '') {
          ui.open("https://cliente.onlaine.com.br/login_redirect.asp?t=" + customerServiceCenterToken.token + "&a=" + customerServiceCenterToken.auth + "&l=" + customerServiceCenterToken.link)
        } else {
          ui.msg(this, 'Informação', 'Seu usuário não foi encontrado na Central do Cliente por favor informe via WhatsApp: 55 (11) 97514-2233')
        }

      }).catch(error => this.responseError(error))

    },
    openDownloadApp() {
      this.$bvModal.show('modal-download-app')
    },

    closeSubmenu() {
      this.$emit("closeSubmenu")
    },
    exit() {
      ui.logout(this);
    }
  }
}
</script>
